var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-live-event"},[_c('y-checkbox',{on:{"change":_vm.noticeChange},model:{value:(_vm.isNotice),callback:function ($$v) {_vm.isNotice=$$v},expression:"isNotice"}},[_vm._v(" Notice before live event ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }